import { FC, PropsWithChildren } from "react";
import { Box, BoxProps, Image, ImageProps, useBreakpointValue } from "@chakra-ui/react";
import { useParallax } from "react-scroll-parallax";
import { ParallaxProps } from "react-scroll-parallax/dist/components/Parallax/types";
import { Container } from "@looksrare/uikit";
import { Text, TextProps } from "uikit";

// Shared breakpoint check
export const useIsMobile = () => useBreakpointValue({ base: true, md: false });

interface SectionContainerProps extends BoxProps {
  baseMaxWidth?: string;
}

export const SectionContainer: FC<PropsWithChildren<SectionContainerProps>> = ({ baseMaxWidth, ...props }) => (
  <Container
    mx="auto"
    maxWidth={!!baseMaxWidth ? { base: baseMaxWidth, md: "1200px" } : "1200px"}
    mb={{ base: 16, md: 0 }}
    overflowX="hidden"
    py={12}
    {...props}
  />
);

export const GreyBox: FC<PropsWithChildren<BoxProps>> = (props) => (
  <Box bg="ui-01" border="1px solid" borderColor="border-01" borderRadius="dialog" {...props} />
);

export const Heading: FC<PropsWithChildren<TextProps>> = (props) => (
  <Text
    as="h2"
    fontSize={{ base: "2.25rem", xl: "4rem" }}
    lineHeight={{ base: "3rem", xl: "4.5rem" }}
    letterSpacing="-0.02em"
    bold
    {...props}
  />
);

export const TextContent: FC<PropsWithChildren<TextProps>> = (props) => (
  <Text
    as="p"
    fontSize={{ base: "1rem", xl: "1.25rem" }}
    lineHeight={{ base: "1.5rem", xl: "2rem" }}
    color="text-03"
    {...props}
  />
);

interface ParallaxImageProps extends ImageProps {
  parallaxProps: ParallaxProps;
}

export const ParallaxImage: FC<PropsWithChildren<ParallaxImageProps>> = ({ src, alt, parallaxProps, ...props }) => {
  const { ref } = useParallax<HTMLImageElement>(parallaxProps);
  return <Image ref={ref} src={src} alt={alt} mx="auto" {...props} />;
};
